<template>
	<!-- 弹出向导层 start-->
	<div id="pop" class="pop" v-bind:style="{ width: screenWidth+'px', height: screenHeight + 'px' }" v-show="pop_show">
		<span class="pop_tan_bg" @click="closeshow()"></span>

		<div id="pop_bodyup" class="pop_tan_content">
			<!-- 动态查询区生成 -->
			<div class="pop_children" v-loading="element_loading" element-loading-text="拼命加载中......"
				element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
				<div class="pop_head_close">
					<a class="close" href="javascript:void(0);" @click="closeshow()"></a>
				</div>
				<div>
					<h5>短途运输杂费&nbsp;&nbsp;合计(默认查询当月合计):</h5>
				</div>
				<div class="content_edit">
					<div class="content_edit_item">
						<button class="pre_btn_ok" @click="refresh_data()">
							刷新
						</button>&nbsp;
						<button class="pre_btn_ok" @click="fun_upd('build')">
							生成杂费合计
						</button>&nbsp;
					</div>
					<div class="content_edit_item" v-show="sheet_flag!=''?true:false">
						<h3 class="red">
							{{sheet_flag}}
						</h3>
					</div>

				</div>

				<div class="content_edit edit-body">
					<div class="content_edit_item tab-border">
						<div class="content_edit_item tab-row">
							<label class="pre-inline">开始日期:</label>
							<el-date-picker v-model="s_date" type="date" class="long1" value-format="yyyy-MM-dd"
								placeholder="选择日期">
							</el-date-picker>
							&nbsp;&nbsp;&nbsp;&nbsp;
							<label class="pre-inline">截至日期:</label>
							<el-date-picker v-model="e_date" type="date" class="long1" value-format="yyyy-MM-dd"
								placeholder="选择日期">
							</el-date-picker>
							<label>司机:</label>
							<input type="text" class="long1" v-model="d_name" />

						</div>
						<!-- 生成的杂费合计 -->
						<div class="content_edit_item tab-row">
							<table class="pre_view_tab" border="1" cellpadding="2" cellspacing="1">
								<tr class="tab_header">
									<td>序号</td>
									<td>单号</td>
									<td>车牌号</td>
									<td>司机</td>
									<td>开始日期</td>
									<td>截至日期</td>
									<td>运输次数</td>
									<td>工资</td>
									<td>备用金分配</td>
									<td>备用金消费</td>
									<td>加气</td>
									<td>ETC</td>
									<td>过路费</td>
									<td>维修</td>
									<td>停车费</td>
									<td>罚款</td>
									<td>加水</td>
									<td>其他</td>
									<td>备用金剩余</td>
									<td>备注</td>
									<td>状态</td>
									<td>修改人</td>
									<td>更新时间</td>
									<td>编辑</td>
								</tr>
								<tr class="tab-body" :id="'selok_'+item.row_num" v-for="item in list_pass_m"
									@click="fun_d_sel(item,'edit')">
									<!-- <a href="#"> -->
									<td>{{item.row_num}}</td>
									<td>{{item.sheet_no}}</td>
									<td>{{item.car_no}}</td>
									<td>{{item.driver}}</td>
									<td>{{item.s_date}}</td>
									<td>{{item.e_date}}</td>
									<td>{{item.dri_num}}</td>
									<td>{{item.dri_amount}}</td>
									<td>{{item.xj_start}}</td>
									<td>{{item.xj_pay}}</td>
									<td>{{item.gas_xj}}</td>
									<td>{{item.etc_xj}}</td>
									<td>{{item.glf_pay}}</td>
									<td>{{item.wh_pay_xj}}</td>
									<td>{{item.tcf_pay}}</td>
									<td>{{item.fk_pay}}</td>
									<td>{{item.jia_pay}}</td>
									<td>{{item.qt_pay}}</td>
									<td>{{item.xj_end}}</td>
									<td>{{item.note}}</td>
									<td>{{item.flag}}</td>
									<td>{{item.u_name}}</td>
									<td>{{item.sys_date}}</td>
									<td><span @click="fun_d_sel('_del',item)">
											<i class="iconfont icon-shanchu"></i>删除
										</span></td>

								</tr>
							</table>
						</div>
					</div>

				</div>



			</div>
		</div>
		<div id="pre_msg_data_wz" style="display:none;"></div>

	</div>
</template>

<script>
	/* 
	维修弹窗。。。。。。。
	*/
	import api from '@/utils/type.js';
	import {
		Sel_page_and_length,
		Method_Common,
		Method_EasySelect
	} from '@/utils/loadhttpdata.js';

	import {
		JsonStr
	} from '@/utils/method.js';
	import {
		GetShort,
		BackSpecial,
		GetRandom
	} from "@/utils/localstore.js";

	import {
		dateFormatbyChina,
		dateFormatToChina,
		Word_Right_Delete,
		ReplaceAll
	} from '@/utils/method.js';

	export default {
		name: "pre_tan_car_over",
		data() {
			return {
				element_loading: false,
				pop_show: false,
				show_btn: true,
				row_id: '',
				sys_date: '',
				sheet_no: '',
				sheet_flag: '',
				screenWidth: '',
				screenHeight: '',
				sel_action: '',
				upd_action: '',

				max_row: [],
				list_m: '',
				parm: [],

				file_show: false,
				file_name: '',

				list_pass_m: [], // 

				sel_id: '',

				// 待选参数
				s_date: '',
				e_date: '',
				d_name: '',
				note: '',


			};
		},
		methods: {
			NextTickName: function(key) {
				// console.log('key=' + key);
				return 'pre' + key;
			},
			checkJson: function(d) {
				let temp = '';
				temp = JSON.stringify(d)
				return temp;
			},
			check_url: function(url) {
				let t = BackSpecial(url);
				// console.log(t);
				return t;
			},
			chang_style: function() {
				this.screenWidth = $(window).width();
				this.screenHeight = $(window).height(); //当前浏览器窗口的 宽高
			},
			showpop: function(parm) {
				this.pop_show = true;
				var Hg = $(document).height();
				// 设置背景高度
				$(".pop_tan_bg").height(Hg);
				// 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
				$(".pop_tan_bg").fadeIn("3000");
				$(".pop_tan_content").fadeIn("3000");
				this.chang_style();
				this.load_data(parm)
			},
			closeshow: function() {
				this.pop_show = false;
				$(".pop_tan_bg").fadeOut("3000");
				$(".pop_tan_content").fadeOut("3000");
				this.screenHeight = 0;
				this.screenWidth = 0;
			},
			load_data: async function(res) {
				// console.log('初始参数', res);

				let r = res;
				// 清理缓存
				this.row_id = '';
				this.sys_date = '';
				this.sel_action = 'exp_dtys_trans_dsum_m';
				this.upd_action = '_dtys_trans_dsum_m';

				this.title = '';
				this.sheet_no = '';
				// this.sheet_flag=r.flag;
				this.parm = []; //主单保存数据
				this.list_pass_m = []; //结算账单
				// this.refresh_data();
			},
			refresh_data: function() {

				this.list_pass_m = []; //结算账单

				this.load_list_m(); // 加载结算账单

			},
			load_list_m: function() {

				this.element_loading = true;
				this.list_pass_m = [];
				let r = (Math.random() + '').substring(0, 8);
				// 加载结算账单
				this.$post(
					api.http_method, Sel_page_and_length(this.sel_action, 1, 100, '', r)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.length > 1 && res[0][0].flag == '1') {
						let arr = res[1];
						// console.log(arr);
						
						for (let i = 0; i < arr.length; i++) {
							let o = {};
							o = arr[i];
							o.row_num = i + 1;
							this.list_pass_m.push(o);
						}
						// console.log(this.list_pass_m);

					} else {
						this.$message({
							message: '没有查询到合计明细!',
							type: 'warning'
						});
					}
				});
			},
			fun_upd: async function(type) {
				// console.log('操作类型=' + type);

				if (type == 'upd' || type == 'del' || type == 'sub' || type == 'bad') {
					if (this.row_id == 0) {
						this.$message({
							message: '请选择要编辑的数据!',
							type: 'warning'
						});
						return;
					}
				}

				let d = [];
				d.push(this.sheet_no);
				d.push(this.note);
				d.push(this.s_date);
				d.push(this.e_date);
				d.push(this.d_name);


				let r = (Math.random() + '').substring(0, 8);
				// console.log(d);
				let temp_data = '';
				temp_data = Method_Common(this.upd_action + '_' + type, this.row_id, this
					.sys_date, d, r);

				this.$post(
					api.http_method, temp_data
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});

						
					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
					this.load_list_m(); //加载结算账单
				});

			},
			//编辑结算 明细//////////////////////
			fun_d_sel: function(type, item) {
				// console.log('结算明细', item);
				this.row_id = 0;
				this.sys_date = '';

				this.row_id = item.id;
				this.sys_date = item.sys_date;

				for (var i = 0; i < this.list_pass_m.length; i++) {
					// console.log(this.data_tab[i]);
					if (this.list_pass_m[i].row_num == item.row_num) {
						document.getElementById('selok_' + item.row_num).style.background = '#92a4f3';
					} else {
						if (this.list_pass_m[i].row_num % 2 == 0) {
							document.getElementById('selok_' + this.list_pass_m[i].row_num).style.background =
								'#fff';
						} else {
							document.getElementById('selok_' + this.list_pass_m[i].row_num).style.background =
								'#f5f5f5';
						}
					}
				}

				if (type == '_del') {
					this.fun_upd('del');
				}

			},
			///////////////////////
			show_detaildata: function(that, item, type) {
				var x = 0,
					y = 0,
					temp_css = '';
				// //console.log('明细数据显示坐标 ' + x + ' ' + y);
				// //console.log(item);
				x = that.clientX + 10;
				y = that.clientY - 80;
				temp_css = "display: block;position: absolute;top:" + y + "px;left:" +
					x +
					"px;background-color: #99CCFF;border: 1px solid black;padding-left: 20px;padding-right: 20px;border-radius: 5px;z-index: 99999;";
				if (type == "0" && item.detail_data.length > 0) {
					this.detail_data = item.detail_data;
					// //console.log($('#pre_detail_data'));
					document.getElementById("pre_detail_data").style.cssText =
						temp_css;
				}
				if (type == "1" && item != '') {
					temp_css +=
						"max-width: 200px;word-break: break-all;padding-top: 5px;padding-bottom: 5px;";
					document.getElementById("pre_msg_data_wz").innerText = BackSpecial(
						item);
					document.getElementById("pre_msg_data_wz").style.cssText = temp_css;
				}
			},
			noshow_detaildata: function() {
				// //console.log('不显示明细');
				document.getElementById("pre_msg_data_wz").style.display = 'none';
			},





		}
	};
</script>


<style scoped>
	.tanfile {
		display: -webkit-inline-box;
		max-height: 60vh;
		overflow: auto;
	}

	.pop_tan_bg {
		width: 100%;
		background: #000000;
		opacity: 0.5;
		position: fixed;
		top: 0;
		left: 0;
		height: 1340px;
		display: none;
		z-index: 9;
	}

	.pop_tan_content {

		height: auto;
		/* background: #faf5f5; */
		background-color: rgb(195, 219, 250);
		position: fixed;
		border-radius: 3px;
		display: none;
		z-index: 10;
		padding: 5px;
		/* overflow: hidden; */

		display: inline-block;
		min-width: 720px;
		/* max-width: 95vw; */
		max-height: 80vh;
		overflow: auto;
	}

	/* .pop_children{
	position: fixed;
	
	z-index: 9999;
} */
	.tab-row {
		display: flex;
		overflow: auto;
		margin: 2px;
		width: 100%;
	}

	.tab-border {

		display: flex;
		flex-direction: column;
		border: 1px solid #aaa;
		border-radius: 5px;
		margin-bottom: 6px;
	}


	/* 表格//////// */

	.tab-body {
		background-color: #fff;
	}

	.tab-body:hover {
		cursor: pointer;
		background-color: #e6e6e6;
	}

	.pre_view_tab td {
		font-size: 12px;
	}

	.pre_view_tab td span {
		width: 24px;
		height: 24px;
		border: 0px;
		text-align: left;
		background-color: #cfcfcf;
		padding: 2px 2px 2px 2px;
		font-size: 14px;
		margin-left: 5px;
		margin-right: 5px;
		border-radius: 5px;
	}

	.pre_view_tab td span:hover {
		cursor: pointer;
		background: #aaa;
		/* font-size: 16px; */
	}

	.edit-body {
		display: flex;
	}

	.edit-row {
		display: flex;
		width: 100%;
		align-items: flex-start;

	}

	.edit-area {
		display: flex;
		flex-direction: column;
		border-top: 1px solid #bcbcbc;
		padding-top: 6px;
		width: 100%;
	}
</style>